module.exports = __webpack_public_path__ + "static/media/Flow Map.9b70d11a.png";